import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import fetchAPI from '../../../lib/utils/fetch-api'

type Meta = {
  platform_admin_host?: string | null
  control_plane_external?: boolean
}

function adminBaseUrl(host: string): string {
  const h = String(host || '')
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/+$/, '')
  return `https://${h}/`
}

/** Map ERP /admin/dealers/* pathname to platform-admin hash route. */
export function platformAdminHash(pathname: string, params: { tenantId?: string; quizId?: string }): string {
  const path = String(pathname || '')
  if (path.includes('/polls/') && params.quizId) {
    return `#/polls/${encodeURIComponent(params.quizId)}`
  }
  if (path.includes('/polls')) return '#/polls'
  if (path.includes('/modules')) return '#/modules'
  if (path.includes('/settings')) return '#/settings'
  if (params.tenantId) return `#/dealers/${encodeURIComponent(params.tenantId)}`
  return '#/'
}

/**
 * Dual-run: ERP /admin/dealers/* → platform-admin host when control plane is external.
 */
export default function PlatformAdminRedirect() {
  const { tenantId, quizId } = useParams<{ tenantId?: string; quizId?: string }>()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    const baked = String(process.env.REACT_APP_PLATFORM_ADMIN_HOST || '').trim()

    const go = (host: string) => {
      const base = adminBaseUrl(host)
      const hash = platformAdminHash(window.location.pathname, { tenantId, quizId })
      window.location.replace(`${base}${hash}`)
    }

    if (baked) {
      go(baked)
      return
    }

    ;(async () => {
      try {
        const res = await fetchAPI('/api/dealers/admin/meta')
        const meta = (res?.data || res) as Meta
        const host = String(meta?.platform_admin_host || '').trim()
        if (!host) {
          if (!cancelled) {
            setError('PLATFORM_ADMIN_HOST не задан — control-plane ещё в ERP.')
          }
          return
        }
        if (!cancelled) go(host)
      } catch (e: any) {
        if (!cancelled) setError(e?.message || 'Не удалось получить meta control-plane')
      }
    })()

    return () => {
      cancelled = true
    }
  }, [tenantId, quizId])

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <p>{error || 'Переход в панель платформы…'}</p>
    </div>
  )
}
